import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";

/* ================= DATA ================= */
const DEFAULT_TRENDING_GAMES = [
  { id: 1, title: "Katana Fruits", image: "/assets/gamescard/fruit-ninja.png", link: "https://thegameio.ng/katana-fruits/" },
  { id: 2, title: "Water Craft", image: "/assets/gamescard/watercraft.png", link: "https://thegameio.ng/watercraft-rush/" },
  { id: 3, title: "Penalty kicks", image: "/assets/gamescard/penaltykicks.png", link: "https://thegameio.ng/penalty-kicks/" },
  { id: 4, title: "Duck Shooter", image: "/assets/gamescard/duck-shooter.png", link: "https://thegameio.ng/duck-shooter/" },
  { id: 5, title: "Ultimate Swish", image: "/assets/gamescard/ultimate-swish.png", link: "https://thegameio.ng/ultimate-swish/" },
  { id: 6, title: "Marble Blast", image: "/assets/gamescard/marbleblast.png", link: "https://thegameio.ng/marbleblast/" },
];

const Trending = () => {
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

  const handleGameClick = (game) => {
    if (!isLoggedIn) {
      navigate("/games");
      return;
    }
    window.open(game.link, "_self", "noopener,noreferrer");
  };

  return (
    <div className="mt-5">
      <div className="w-full py-12 px-4">
        <div className="max-w-6xl mx-auto">

          {/* ================= HEADER ================= */}
          <div className="flex justify-between items-center mb-10">
            <h2 className="text-white text-3xl font-bold">
              <span>Trending</span> Games
            </h2>

            <div className="flex gap-3">
              <button
                onClick={() => navigate("/games")}
                className="btn-hover bg-[#3a3f5c] text-white px-5 py-2 rounded-lg"
              >
                <span>View All</span>
              </button>

              <button className="swiper-button-prev-trending btn-hover bg-[#3a3f5c] w-10 h-10 rounded-lg flex items-center justify-center">
                <span><IoIosArrowBack color="#fff" /></span>
              </button>

              <button className="swiper-button-next-trending btn-hover bg-[#3a3f5c] w-10 h-10 rounded-lg flex items-center justify-center">
                <span><IoIosArrowForward color="#fff" /></span>
              </button>
            </div>
          </div>

          {/* ================= SLIDER ================= */}
          <Swiper
            modules={[Navigation, Autoplay]}
            navigation={{
              prevEl: ".swiper-button-prev-trending",
              nextEl: ".swiper-button-next-trending",
            }}
            autoplay={{ delay: 3500, disableOnInteraction: false }}
            loop
            spaceBetween={20}
            breakpoints={{
              0: { slidesPerView: 2 },
              640: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
              1280: { slidesPerView: 5 },
            }}
          >
            {DEFAULT_TRENDING_GAMES.map((game) => (
              <SwiperSlide key={game.id}>
                <div
                  onClick={() => handleGameClick(game)}
                  className="group cursor-pointer"
                >
                  {/* ✅ PERFECT SQUARE CARD */}
                  <div className="aspect-square w-full rounded-2xl overflow-hidden border-2 border-[#36363e] group-hover:border-yellow-500 transition-all duration-300">
                    <img
                      src={game.image}
                      alt={game.title}
                      className="w-full h-full object-fill transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>

                  {/* TITLE */}
                  <h3 className="mt-4 text-center text-white text-lg font-semibold">
                    {game.title}
                  </h3>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      {/* ================= BUTTON HOVER ================= */}
      <style>{`
        .btn-hover {
          position: relative;
          overflow: hidden;
        }
        .btn-hover::before,
        .btn-hover::after {
          content: "";
          position: absolute;
          left: 0;
          width: 100%;
          height: 50%;
          background: #249f22;
          transform: scaleX(0);
          transition: transform 0.35s ease;
          z-index: 0;
        }
        .btn-hover::before {
          top: 0;
          transform-origin: left;
        }
        .btn-hover::after {
          bottom: 0;
          transform-origin: right;
        }
        .btn-hover:hover::before,
        .btn-hover:hover::after {
          transform: scaleX(1);
        }
        .btn-hover span {
          position: relative;
          z-index: 1;
        }
      `}</style>
    </div>
  );
};

export default Trending;
